// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__AdminIdentitiesSubHeader from "../../../components/molecules/AdminSidebar/AdminIdentitiesSubHeader.js";
import * as Buhta_cabinet__Btn from "../../../components/html/Btn.js";
import * as Buhta_cabinet__ControlAdmin from "../../../grpc/ControlAdmin.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__ErrorPage from "../../ErrorPage.js";
import * as Buhta_cabinet__Field from "../../../components/html/Field.js";
import * as Buhta_cabinet__FileUploader2 from "../../../components/molecules/FileUploader2.js";
import * as Buhta_cabinet__Form from "../../../core/Form.js";
import * as Buhta_cabinet__Identity from "../../../models/Identity.js";
import * as Buhta_cabinet__Keychain from "../../../grpc/Keychain.js";
import * as Buhta_cabinet__Link from "../../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__PhoneField from "../../../components/html/PhoneField.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_cabinet__Timestamp from "../../../util/Timestamp.js";
import * as Buhta_cabinet__ToastSender from "../../../util/ToastSender.js";
import * as Buhta_components__LoadingDiv from "../../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../packages/util/lib/DateTime.js";
import * as Formating from "../../../../../../packages/util/lib/Formating.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__Option from "melange/option.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function IdentityGeneralPage(Props) {
  let openMenu = Props.openMenu;
  const match = React.useState(function () {
        return "";
      });
  const setPhone = match[1];
  const phone = match[0];
  const match$1 = React.useState(function () {
        return "";
      });
  const setName = match$1[1];
  const name = match$1[0];
  const match$2 = React.useState(function () {
        return "";
      });
  const setLastName = match$2[1];
  const lastName = match$2[0];
  const match$3 = React.useState(function () {
        return false;
      });
  const setModalPhoto = match$3[1];
  const modalPhoto = match$3[0];
  const match$4 = React.useState(function () {
        return true;
      });
  const setDisabledButton = match$4[1];
  const disabledButton = match$4[0];
  const match$5 = React.useState(function () {
        return "";
      });
  const setEmail = match$5[1];
  const email = match$5[0];
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match$6 = Buhta_core__Tenant.useTenant(undefined);
  const partial_arg = match$6[0];
  const form = Buhta_cabinet__Form.useForm(function (param) {
        return Buhta_cabinet__Keychain.KeyService.create(partial_arg, param);
      });
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
  const match$7 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match$7[1];
  const match$8 = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match$8[0];
  let identityId;
  if (typeof currentRoute === "number" || currentRoute.TAG !== /* Admin */7) {
    identityId = "";
  } else {
    const match$9 = currentRoute._0;
    if (typeof match$9 === "number" || match$9.TAG !== /* Identities */2) {
      identityId = "";
    } else {
      const match$10 = match$9._0;
      identityId = typeof match$10 === "number" || match$10._1 ? "" : match$10._0;
    }
  }
  const match$11 = Buhta_cabinet__Identity.use(undefined);
  const identity = match$11[0];
  React.useEffect((function () {
          if (typeof identity !== "string" && identity.NAME === "Data") {
            const profile = identity.VAL.profile;
            const profile$1 = profile !== undefined ? profile : ({
                  id: 0,
                  email: "",
                  phone: "",
                  first_name: "",
                  last_name: "",
                  userpic_url: "",
                  tenants: /* [] */0,
                  create_time: undefined
                });
            Curry._1(setName, (function (param) {
                    return profile$1.first_name;
                  }));
            Curry._1(setLastName, (function (param) {
                    return profile$1.last_name;
                  }));
            Curry._1(setEmail, (function (param) {
                    return profile$1.email;
                  }));
            Curry._1(setPhone, (function (param) {
                    return profile$1.phone;
                  }));
          }
          
        }), [identity]);
  const fileField = Buhta_cabinet__Form.useField(form, undefined, undefined, (function (value) {
          if (Stdlib__Option.is_some(value)) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          } else {
            return {
                    TAG: /* Error */1,
                    _0: "выберите файл"
                  };
          }
        }));
  const handleUpload = function (file) {
    Curry._1(fileField.onChange, file);
    Curry._1(setDisabledButton, (function (param) {
            return !disabledButton;
          }));
  };
  const modal = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.P.make, {
                                    className: "font-semibold",
                                    children: "Фото профиля"
                                  }),
                              JsxRuntime.jsx("img", {
                                    className: "cursor-pointer",
                                    src: StaticAsset.src("/static/icons/close.svg"),
                                    onClick: (function (param) {
                                        Curry._1(setModalPhoto, (function (param) {
                                                return !modalPhoto;
                                              }));
                                      })
                                  })
                            ],
                            className: "border-b border-gray-main py-4 px-6 flex justify-between items-center gap-x-2"
                          }),
                      JsxRuntime.jsx(Buhta_cabinet__FileUploader2.make, {
                            onChange: handleUpload,
                            disabledButton: disabledButton
                          })
                    ],
                    className: "block relative mx-auto top-50 animate-fadeScaleIn duration-200 z-30 w-106 shadow-panel bg-white rounded"
                  }),
              className: "fixed top-0 left-0 right-0 bottom-0 z-20 bg-black bg-opacity-70",
              onClick: (function (param) {
                  Curry._1(setModalPhoto, (function (param) {
                          return false;
                        }));
                })
            }),
        className: "flex absolute w-full h-full items-center justify-center"
      });
  const subheader = JsxRuntime.jsx(Buhta_cabinet__AdminIdentitiesSubHeader.make, {
        currentRoute: currentRoute,
        identityId: identityId
      });
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
        title: "Общая информация"
      });
  let tmp;
  if (typeof identity === "string") {
    tmp = JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {});
  } else if (identity.NAME === "Data") {
    const profile = identity.VAL.profile;
    const profile$1 = profile !== undefined ? profile : ({
          id: 0,
          email: "",
          phone: "",
          first_name: "",
          last_name: "",
          userpic_url: "",
          tenants: /* [] */0,
          create_time: undefined
        });
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("img", {
                  className: "w-5 h-5",
                  src: StaticAsset.src("/static/icons/back-arrow.svg")
                }),
            JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                  className: "ml-4 text-white",
                  children: profile$1.first_name + (" " + profile$1.last_name)
                })
          ],
          className: "flex items-center"
        });
  } else {
    console.log(identity.VAL);
    tmp = JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {});
  }
  const headerMobile = JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                              route: {
                                TAG: /* Admin */7,
                                _0: {
                                  TAG: /* Identities */2,
                                  _0: /* List */0
                                }
                              },
                              className: " flex justify-between",
                              children: tmp
                            }),
                        className: "flex items-center gap-2"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                className: "border-l border-asphalt-dark h-5"
                              }),
                          JsxRuntime.jsx("button", {
                                children: JsxRuntime.jsx("img", {
                                      className: "w-6 h-6",
                                      src: StaticAsset.src("/static/icons/menu-white-24.svg")
                                    }),
                                onClick: openMenu
                              })
                        ],
                        className: "flex items-center gap-2"
                      })
                ],
                className: "h-14 bg-black flex justify-between px-4"
              }),
          subheader
        ],
        className: "flex flex-col"
      });
  let tmp$1;
  if (typeof identity === "string") {
    tmp$1 = JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {});
  } else if (identity.NAME === "Data") {
    const identity$1 = identity.VAL;
    const profile$2 = identity$1.profile;
    const profile$3 = profile$2 !== undefined ? profile$2 : ({
          id: 0,
          email: "",
          phone: "",
          first_name: "",
          last_name: "",
          userpic_url: "",
          tenants: /* [] */0,
          create_time: undefined
        });
    const profile$4 = identity$1.profile;
    const userpic = profile$4 !== undefined ? profile$4.userpic_url : "";
    const create_time = DateTime.toLocalFormat(Buhta_cabinet__Timestamp.toDateTime(Belt__Belt_Option.getWithDefault(profile$3.create_time, Buhta_cabinet__Timestamp.fromString("01.01.2000"))));
    tmp$1 = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                          children: [
                            userpic === "" ? JsxRuntime.jsx("div", {
                                    children: profile$3.first_name.substring(0, 1),
                                    className: "w-20 h-20 rounded-full bg-asphalt flex justify-center items-center text-white text-2xl font-semibold"
                                  }) : JsxRuntime.jsx("img", {
                                    className: "w-20 h-20 rounded-50pct",
                                    src: profile$3.userpic_url
                                  }),
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx("img", {
                                        src: StaticAsset.src("/static/icons/edit-white-16.svg")
                                      }),
                                  className: "bg-black/40 absolute bottom-0 w-full cursor-pointer hidden group-hover:flex justify-center py-1",
                                  onClick: (function (param) {
                                      Curry._1(setModalPhoto, (function (param) {
                                              return !modalPhoto;
                                            }));
                                    })
                                })
                          ],
                          className: "relative rounded-full w-20 overflow-hidden group"
                        }),
                    JsxRuntime.jsx(Buhta_components__Text.H1.make, {
                          children: profile$3.first_name + (" " + profile$3.last_name)
                        }),
                    modalPhoto ? modal : null
                  ],
                  className: " flex gap-6 items-center"
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                          label: "Имя",
                          type_: "text",
                          size: "m",
                          onChange: (function (value) {
                              Curry._1(setName, (function (param) {
                                      return value;
                                    }));
                            }),
                          className: "grow",
                          value: name
                        }),
                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                          label: "Фамилия",
                          type_: "text",
                          size: "m",
                          onChange: (function (value) {
                              Curry._1(setLastName, (function (param) {
                                      return value;
                                    }));
                            }),
                          className: "grow",
                          value: lastName
                        })
                  ],
                  className: "mt-6 flex justify-between gap-4"
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(Buhta_cabinet__PhoneField.make, {
                        value: Formating.formatPhone(phone),
                        onChange: (function (value) {
                            Curry._1(setPhone, (function (param) {
                                    return value;
                                  }));
                          }),
                        label: "Номер телефона"
                      }),
                  className: "mt-6 relative"
                }),
            JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                  label: "Email",
                  type_: "email",
                  size: "m",
                  onChange: (function (value) {
                      Curry._1(setEmail, (function (param) {
                              return value;
                            }));
                    }),
                  autoComplete: "off",
                  className: "mt-6",
                  value: email
                }),
            JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                  title: "Сохранить",
                  onClick: (function (param) {
                      const updateData = {
                        family_name: lastName,
                        given_name: name,
                        email: email,
                        phone: phone,
                        userpic_id: undefined,
                        password: undefined
                      };
                      const __x = Buhta_cabinet__ControlAdmin.AdminIdentityService.update(tenant, identityId, updateData);
                      $$Promise.get(__x, (function (result) {
                              if (result.TAG === /* Ok */0) {
                                return Curry._1(dispatchToasts, {
                                            TAG: /* Add */0,
                                            _0: {
                                              id: Buhta_core__Toast.generateId(undefined),
                                              text: "Настройки сохранены",
                                              kind: "success",
                                              onClick: (function (param) {
                                                  
                                                })
                                            }
                                          });
                              } else {
                                return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при сохранении");
                              }
                            }));
                    }),
                  className: "mt-4 w-full py-3"
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          className: "flex"
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                  className: "text-default-gray",
                                  children: "с"
                                }),
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                  className: "ml-1 text-black",
                                  children: create_time
                                })
                          ],
                          className: "flex"
                        })
                  ],
                  className: "flex justify-between mt-6"
                })
          ],
          className: "bg-white lg:w-140.5 p-10 mt-6 rounded shadow-card w-auto mx-4"
        });
  } else {
    console.log(identity.VAL);
    tmp$1 = JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {});
  }
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
              header: deviceType === "mobile" ? headerMobile : header,
              children: JsxRuntime.jsx("div", {
                    children: tmp$1,
                    className: "w-full flex flex-col items-center"
                  }),
              className: "bg-gray-pale"
            });
}

const make = IdentityGeneralPage;

export {
  make ,
}
/* Buhta_cabinet__AdminIdentitiesSubHeader Not a pure module */
